import { useSelector } from 'react-redux';
import { getMessageLogParams } from '../../../../selectors/groupsBackroom';

export function useMessageLogParams() {
  return useSelector(getMessageLogParams);
}
